;(function(w){
	function FormularioSelect(select){
		
		select.options[0].disabled = true;
		$(select).selectric('refresh');
		
		this.is_autocomplete = false;
		var agrupado;
		
		if($(select).find('optgroup').length > 0){
			agrupado = true;
		}else{
			agrupado = false;
		}
		var active = true;
		var required = true;

		this.esRequerido = function(requerido){
			required=requerido;
		}
	
		this.disableFirst=function(value){
			select.options[0].disabled = value;
			$(select).selectric('refresh');
		}

		this.esCorrecto = function(){
			//TODO: required
			if (this.is_autocomplete){
				var input_value = $(select).closest('.selectric-wrapper').find('input[class="label"]').val();
				if (select.selectedIndex === 0 && input_value !== ''){
					return false;
				}
				return true;
			}
			return select.selectedIndex != 0;
		}

		this.setError = function(valor){
			if(valor){
				$(select).addClass('error');
				$(select).closest('.selectric-wrapper').find('> .selectric').addClass('error');
			}else{
				$(select).removeClass('error');
				$(select).closest('.selectric-wrapper').find('> .selectric').removeClass('error');
			}
		}

		this.autocompleteReset = function(){
			$(select).closest('.selectric-wrapper').find('input[class="label"]').val('');
		}

		this.autocomplete = function(options){
			this.is_autocomplete = true;
			$(select)
				.on('selectric-open', function() {
					$(select).closest('.selectric-wrapper').find('input[class="label"]').focus();
				})
				.on('change', function() {
					var selname = $(select).closest('.selectric-wrapper').find('.selectric-items li[class="selected"], .selectric-items li[class="last selected"]').text();
					if (selname){
						$(select).closest('.selectric-wrapper').find('input[class="label"]').val(selname);
					}
				});
			$(select).closest('.selectric-wrapper').find('p[class="label"]').remove();
			$(select).closest('.selectric-wrapper').find('div[class="selectric"]').append($('<input placeholder="' + options.placeholder + '"/>').
				css('margin', 0).
				attr('type', 'text').
				attr('value', '').
				addClass('label').
				on('click', function (e){
					e.preventDefault();
				}).
				on('keyup', function (e){
					if ((e.which < 65 || e.which > 122) && (e.which < 48 || e.which > 57) && e.which !== 46 && e.which !== 8){
						return;
					}
					var country_selected = $(select).attr('country_selected');
					var q = $(this).val().trim().toLowerCase();

					var options = $(select).find('option[country_code="' + country_selected + '"]');
					options.attr('disabled','disabled');
					select.value = 0;
					options.each(function (){
						if($(this).text().toLowerCase() === q){
							select.value = $(this).val();
							$(this).removeAttr('disabled');
						} else if($(this).text().toLowerCase().indexOf(q) === 0){
							$(this).removeAttr('disabled');
						}						
					});
					$(select).selectric('refresh').selectric('open');
				})

			);
			
		}

		this.show = function(){
			active = true;
			$(select).closest('.selectric-wrapper').parent().css('display', 'block');
		}

		this.hide = function(){
			active = false;
			$(select).closest('.selectric-wrapper').parent().css('display', 'none');
		}

		this.isActive = function(){
			return active;
		}


		this.getInput = function(){
			return select;
		}
	
		this.getValor = function(){
			return select.value;
		}

		this.getSelect = function(){
			return select;
		}

		this.getSelectedOption = function(){
			return select.options[select.selectedIndex];
		}

		this.getTexto = function(){
			if(select.selectedIndex != 0){
				return select.options[select.selectedIndex].text;
			}else{
				return '';
			}
		}

		this.highlight = function(){
			$(select).closest('.selectric-wrapper').find('> .selectric').addClass('highlight');
			
			setTimeout(function(){
				$(select).closest('.selectric-wrapper').find('> .selectric').removeClass('highlight');	
			},1500);
		}

		this.resetear = function(){
			$(select).closest('.selectric-wrapper').find('> .selectric').removeClass('error');
			$(select).prop('selectedIndex', 0).selectric('refresh');
		}

		this.find = function(value){
			return $(select).find(value);
		}

		this.seleccionar = function(valor){
			if (this.is_autocomplete){
				if(valor == 0 || valor === 0){
					select.value = 0;
					$(select).selectric('refresh');
					this.autocompleteReset();
					return;
				}
				
				var ops = $(select).find('option[value]');
				if(ops.length > 0){
					var opsel = ops.filter(function (el){
						return this.value.indexOf(valor) !== -1;
					});
					if(opsel){
						select.value = $(opsel[0]).val();
						$(select).selectric('refresh');
						
						var selname = $(opsel[0]).text();
						if (selname){
							$(select).closest('.selectric-wrapper').find('input[class="label"]').val(selname);
						}
					}
				}				
				return;
			}
			if($(select).find('option[value="'+valor+'"]').length > 0){
				select.value = valor;	
				$(select).selectric('refresh');
			}
			
		}

		this.showByQuery = function(query){
			$(select).find('option'+query).removeAttr('disabled');
			$(select).selectric('refresh');
		}

		this.hideByQuery = function(query){
			this.seleccionar(0);
			$(select).find('option'+query).attr('disabled','disabled');
			$(select).selectric('refresh');
		}

		this.seleccionarByOptionQuery = function(query){
			var option = $(select).find('option'+query)[0];
			
			if(option != undefined){
				select.selectedIndex = option.index;	
				$(select).selectric('refresh');

				return true;
			}else{
				return false;
			}
		}

		this.getAttr = function(key){
			return $(select).attr(key);
		}

		this.setAttr = function(key, value){
			$(select).attr(key, value);
		}

		this.removeAttr = function(key){
			$(select).removeAttr(key);
		}

		this.set = function(options){
			$(select).find('option').not(':eq(0)').remove();
			
			var option;
			
			var selected_selectric = 0;
			
			if(agrupado){
				for(var i=0; i < options.length; i++){
					option = document.createElement('option');
					option.text = options[i].nombre;
					option.value = options[i].valor;
					if(option.selected){
						selected_selectric =  i + 1;
						option.selected = options[i].selected;
					}
					if(typeof options[i].params != 'undefined'){
						for(param in options[i].params){
							$(option).attr('data-' + param, options[i].params[param]);
						}
					}

					if($(select).attr('data-group-escuela')){
						$(select).find('optgroup[data-group-tipo="'+options[i].escuela_id+'"]').eq(0).append(option);
					} else {
						$(select).find('optgroup[data-group-tipo="'+options[i].tipo+'"]').eq(0).append(option);
					}
					
				}

			}else{
				for(var i=0; i < options.length; i++){
					if (options[i].selected){
						selected_selectric =  i + 1;
					}
					$(select).append('<option value="'+options[i].valor+'" '+(options[i].selected ? 'selected' : '')+'>'+options[i].nombre+'</option>')
				}	
			}

			$(select).find('optgroup').each(function(){
				if($(this).find('option').length == 0){
					$(this).attr('disabled', true);
				}else{
					$(this).attr('disabled', false);
				}
			})

			$(select).prop('selectedIndex', selected_selectric).selectric('refresh');	
		}

		this.clean = function(){
			$(select).find('option').not(':eq(0)').remove();
			$(select).prop('selectedIndex', 0).selectric('refresh');
		}
	}
	
	w.FormularioSelect = FormularioSelect;
})(window)